import * as React from "react";
import {
  Field,
  FormSubmitHandler,
  reduxForm,
  InjectedFormProps,
} from "redux-form";

import * as constants from "../constants";
import validate from "../supp-form-validation";
import { TextArea, TextInput } from "../../../components";

export interface SuppInfoFormProps {
  isTOCChecked: boolean;
  isPaymentUpfrontForced: boolean;
  isSubmitting: boolean;
  paymentUpfrontOptions: JSX.Element[];
  additionalDesignOptions: JSX.Element[];
  initialValues: Partial<SuppInfoFormValues>;
  onSubmit: FormSubmitHandler<SuppInfoFormValues>;
}

export interface SuppInfoFormValues {
  special_req?: string;
  has_payment_upfront?: string;
  payment_upfront_rate?: string;
  num_additional_designs?: string;
  has_express_req?: string;
  vat?: string;
  customer_name_first?: string;
  customer_name_last?: string;
  customer_phone?: string;
  customer_email?: string;
  redeem_code?: string;
}

export interface AugmentedSuppInfoFormProps
  extends InjectedFormProps<SuppInfoFormValues, SuppInfoFormProps>,
    SuppInfoFormProps {}

const SuppInfoForm = (props: AugmentedSuppInfoFormProps) => (
  <form className="form-horizontal info-form" onSubmit={props.handleSubmit}>
    <fieldset disabled={props.isSubmitting}>
      <div className="form-group">
        <label className="control-label col-md-4">
          Yêu cầu kỹ thuật đặc biệt
        </label>
        <div className="col-md-8">
          <Field
            className="form-control"
            name="special_req"
            component={TextArea}
            placeholder="Tôi muốn vẽ tay, chibi các nhân vật! Tôi không có logo gốc, cần đồ lại!"
            rows={5}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Super Express</label>
        <div className="col-md-8">
          <div className="radio-block">
            <Field
              type="radio"
              id="express-neg"
              component="input"
              name="has_express_req"
              value="false"
            />
            <label htmlFor="express-neg">
              <span className="radio-text">Bình thường</span>
            </label>
          </div>
          <div className="radio-block">
            <Field
              type="radio"
              id="express-pos"
              component="input"
              name="has_express_req"
              value="true"
            />
            <label htmlFor="express-pos">
              <span className="radio-text">Có, tôi cần gấp!</span>
            </label>
          </div>
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Thanh toán trước</label>
        <div className="col-md-8">
          <div className="radio-block">
            <Field
              type="radio"
              id="payment-upfront-neg"
              component="input"
              name="has_payment_upfront"
              value="false"
              disabled={props.isPaymentUpfrontForced}
            />
            <label htmlFor="payment-upfront-neg">
              <span className="radio-text">Không</span>
            </label>
          </div>
          <div className="radio-block">
            <Field
              type="radio"
              id="payment-upfront-pos"
              component="input"
              name="has_payment_upfront"
              value="true"
            />
            <label htmlFor="payment-upfront-pos">
              <div className="payment-upfront__container">
                <span className="radio-text">Có</span>
                <Field
                  name="payment_upfront_rate"
                  component="select"
                  className="form-control-select form-control-select-inline"
                >
                  {props.paymentUpfrontOptions}
                </Field>
              </div>
            </label>
          </div>
          <p className="help-block">
            Chúng tôi sẽ giảm giá! (trừ trực tiếp vào sản phẩm) nếu bạn chọn
            thanh toán trước
          </p>
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Thiết kế thêm mẫu</label>
        <div className="col-md-8">
          <Field
            name="num_additional_designs"
            component="select"
            className="form-control-select form-control-select-inline"
          >
            {props.additionalDesignOptions}
          </Field>
          <p className="help-block">
            Số mẫu bạn muốn thêm ngoài số mẫu mặc định
          </p>
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Xuất hoá đơn</label>
        <div className="col-md-8">
          <div className="radio-block">
            <Field
              type="radio"
              id="vat-neg"
              component="input"
              name="vat"
              value="false"
            />
            <label htmlFor="vat-neg">
              <span className="radio-text">Không</span>
            </label>
          </div>
          <div className="radio-block">
            <Field
              type="radio"
              id="vat-pos"
              component="input"
              name="vat"
              value="true"
            />
            <label htmlFor="vat-pos">
              <span className="radio-text">Có</span>
            </label>
          </div>
        </div>
      </div>
      <hr />
      <p className="headline-block">
        Vui lòng cho chúng tôi biết thông tin của bạn, chuyên gia tư vấn sẽ liên
        hệ với bạn ngay sau khi <strong>Đặt hàng</strong>
      </p>
      <div className="form-group">
        <label className="control-label col-md-4">Họ</label>
        <div className="col-md-8">
          <Field
            type="text"
            name="customer_name_first"
            component={TextInput}
            placeholder="Nguyễn"
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Tên</label>
        <div className="col-md-8">
          <Field
            type="text"
            name="customer_name_last"
            component={TextInput}
            placeholder="Văn A"
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Điện thoại</label>
        <div className="col-md-8">
          <Field
            type="tel"
            name="customer_phone"
            component={TextInput}
            placeholder="Số điện thoại"
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Email</label>
        <div className="col-md-8">
          <Field
            type="email"
            name="customer_email"
            component={TextInput}
            placeholder="Email"
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-md-4">Mã giảm giá</label>
        <div className="col-md-8">
          <Field
            type="text"
            name="redeem_code"
            component={TextInput}
            placeholder="Code"
          />
        </div>
      </div>
    </fieldset>
  </form>
);

export default reduxForm<SuppInfoFormValues, SuppInfoFormProps>({
  form: constants.SUPP_INFO_FORM,
  validate,
})(SuppInfoForm);



// WEBPACK FOOTER //
// ./src/routes/Step5/components/SuppInfoForm.tsx